import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { WOW } from 'wowjs';
import 'animate.css';
import Pricing from './Pricing';
import CTA from './CTA';
import Contact from './Contact';
import EmpathySection from './EmpathySection';
import HowItWorks from './HowItWorks';
import Reviews from './Reviews';
import About from './About';
import Problem from './Problem';
import AuthCheck from './AuthCheck';
import { motion } from 'framer-motion';




const Home = () => {
  useEffect(() => {
    // Initialize WOW
    const wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    });
    wow.init();
  }, []);

  const words = ['Visible', 'Simple', 'Relative', 'Effective', 'Accurate', 'Efficient', 'Remarkable', 'Easy'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const chatBubble = document.querySelector('.chat-bubble');

    function updateChatBubble() {
      if (chatBubble) {
        chatBubble.style.opacity = 0;
        chatBubble.style.transform = 'translateY(-20px)';
        setTimeout(() => {
          chatBubble.textContent = words[currentWordIndex];
          chatBubble.style.opacity = 0;
          chatBubble.style.transform = 'translateY(20px)';
          setTimeout(() => {
            chatBubble.style.opacity = 1;
            chatBubble.style.transform = 'translateY(0)';
          }, 350);
          setCurrentWordIndex((currentWordIndex + 1) % words.length);
        }, 450);
      }
    }

    const intervalId = setInterval(updateChatBubble, 4000);

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, [currentWordIndex, words]);


  // Value stack component
  const Value = ({ text }) => {
    return (
        <div className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.7s">
          <h4 className="emphasize-text">{text}</h4>
        </div>
    );
  };


  return (
    <>
    <AuthCheck navigateTo="dashboard" />
      {/* Main banner */}
      <div className="main-banner wow fadeIn" id="home" data-wow-duration="1s" data-wow-delay="0.5s">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="w-full md:w-1/2 px-4 md:px-8 mb-8 md:mb-0">
              <div className="left-content show-up header-text wow fadeInLeft" data-wow-duration="1s" data-wow-delay="1s">
                <h2 className="home-title text-3xl md:text-4xl lg:text-5xl">Church Groups <br /> Made <span className="chat-bubble">Easy</span></h2>
                {/* <h3 className="home-subtitle text-lg md:text-xl">The messaging app to connect and <strong>grow your church</strong></h3> */}
                <h3 className="home-subtitle text-lg md:text-xl">Smarter connections ministry. All inside one messaging app.</h3>
                <br />
                <div className="cta-small-button scroll-to-section">
                  <Link to="/sign-in">Start Today</Link>
                </div>
              </div>
            </div>
            
            <div className="w-full md:w-1/2 flex justify-center">
              <motion.div
                className="relative z-20"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8, duration: 0.8 }}
              >
                {/* Floating chat bubbles */}
                {[
                  { text: "Hey team! 👋", side: "left", delay: 1 },
                  { text: "See you Sunday!", side: "right", delay: 2 },
                  { text: "Can't wait until next time!", side: "left", delay: 4.5 },
                  { text: "Bible study tonight!", side: "right", delay: 5.5 },
                  { text: "Welcome new members!", side: "left", delay: 8 },
                  { text: "Great service today ✨", side: "right", delay: 9 }
                ].map((bubble, index) => (
                   <motion.div
                    key={index}
                    className={`absolute ${bubble.side === 'left' ? '-left-0' : '-right-0'} top-1/2 z-50`}
                    initial={{ opacity: 0, y: 100 }}
                    animate={{ 
                      opacity: [0, 1, 1, 0],
                      y: [100, -40, -70, -100],
                      x: bubble.side === 'left' ? [0, 10, 5, 15] : [0, -10, -5, -15]
                    }}
                    transition={{
                      duration: 5,
                      delay: bubble.delay,
                      repeat: Infinity,
                      repeatDelay: 6,
                      ease: "easeInOut"
                    }}
                  >
                    <div className={`
                      relative bg-white rounded-2xl px-3 py-2 shadow-lg text-sm text-gray-800 max-w-32
                      ${bubble.side === 'left' ? 'rounded-bl-sm' : 'rounded-br-sm'}
                    `}>
                      {bubble.text}
                      {/* Chat bubble tail */}
                      <div className={`
                        absolute top-4 w-0 h-0 
                        ${bubble.side === 'left' 
                          ? '-left-2 border-t-8 border-r-8 border-r-white border-t-transparent' 
                          : '-right-2 border-t-8 border-l-8 border-l-white border-t-transparent'
                        }
                      `} />
                    </div>
                  </motion.div>
                ))}
                
                <motion.img
                  src="/assets/images/joltchat-group-msg.png"
                  alt="JoltChat Main Interface"
                  className="max-w-2xl w-full h-auto relative z-30 drop-shadow-2xl mr-24 mt-20"
                  whileHover={{ scale: 1.02, y: -5 }}
                  transition={{ duration: 0.3 }}
                />
              </motion.div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Value stack */}
      <div className="py-12 md:pt-24 px-4 md:px-16">
        <div className="container mx-auto">
          <div className="flex flex-col md:flex-row justify-around items-center space-y-6 md:space-y-0">
            <Value text="Be Relational" />
            <Value text="Save Time" />
            <Value text="Grow Attendance" />
          </div>
        </div>
      </div>    

    <Problem />
    <About />
    <Reviews />
    <HowItWorks />
    <EmpathySection />
    <Pricing />
    <CTA />
    <Contact />

    </>
  );
};

export default Home;